import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProgressHistoryStoreActions,
  ProgressHistoryStoreSelectors,
  ProgressHistoryStoreReducer,
} from './index';
import { ProgressHistoryReportDto } from '@cradua/data';

@Injectable()
export class ProgressHistoryFacade {
  constructor(
    private store: Store<
      ProgressHistoryStoreReducer.ProgressHistoryPartialState
    >
  ) {}

  projectManagementRecord$ = this.store.select(
    ProgressHistoryStoreSelectors.getSelected
  );
  searchedStudentRecord$ = this.store.select(
    ProgressHistoryStoreSelectors.getSearchStudentRecord
  );

  projectManagementRecordError$ = this.store.select(
    ProgressHistoryStoreSelectors.getProgressHistoryError
  );

  getselected() {
    return this.store.select(ProgressHistoryStoreSelectors.getSelected);
  }

  get isLoadingProgressHistory() {
    this.store.dispatch(ProgressHistoryStoreActions.loadProgressHistory());
    return this.store.select(
      ProgressHistoryStoreSelectors.loadingProgressHistory
    );
  }

  get loadProgressHistory() {
    this.store.dispatch(ProgressHistoryStoreActions.loadProgressHistory());
    return this.store.select(
      ProgressHistoryStoreSelectors.getAllProgressHistory
    );
  }

  searchProgressHistoryRecord(query) {
    this.store.dispatch(
      ProgressHistoryStoreActions.searchProgressHistoryRecord({ query })
    );
  }

  addProgressHistory(newProgressHistory: ProgressHistoryReportDto[]) {
    this.store.dispatch(
      ProgressHistoryStoreActions.addProgressHistory({
        newProgressHistory,
      })
    );
  }

  updateProgressHistory(updateProgressHistory: ProgressHistoryReportDto[]) {
    this.store.dispatch(
      ProgressHistoryStoreActions.updateProgressHistory({
        updateProgressHistory,
      })
    );
  }

  removeProgressHistory(ids: string[]) {
    this.store.dispatch(
      ProgressHistoryStoreActions.removeProgressHistory({ ids })
    );
  }
}
